import { makeDownloadApkLink } from 'app/utils/hooks'
import { Versions } from 'domain/AppInfo'

export const copyApkLinkToClipboard = (version: Versions) =>
    navigator.clipboard.writeText(
        window.location.origin +
            makeDownloadApkLink(
                version.appId.toString(),
                version.id.toString(),
            ),
    )
